import { render, staticRenderFns } from "./HrSalaryWealHeal.vue?vue&type=template&id=683b0633&scoped=true&"
import script from "./HrSalaryWealHeal.vue?vue&type=script&lang=js&"
export * from "./HrSalaryWealHeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683b0633",
  null
  
)

export default component.exports